import * as React from 'react';

import TrackAsset from '../TrackAsset';
import useClippableTrackAsset, {
  UseClippableTrackAssetProps,
} from './useClippableTrackAsset';

export type ClippableTrackAssetProps = UseClippableTrackAssetProps;

const ClippableTrackAsset: React.FC<UseClippableTrackAssetProps> = props => {
  const { trackAssetProps } = useClippableTrackAsset(props);

  return <TrackAsset {...trackAssetProps} />;
};

export default ClippableTrackAsset;
